/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { M2MClientDetailsPage } from '@/pages/M2MClients/M2MClientDetailsPage';

export function M2MClientDetailsRoute() {
  return <M2MClientDetailsPage />;
}
